module.exports = {"title":"Tickets Assignment","noChange":"No changes","both":"Both","boxOfficeOnly":"Box office only","noOne":"No one","saveClose":"Save and Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/GlobalPriceModal/locales/fr.json
// module id = 1670
// module chunks = 0